import React from "react";
import { Button } from "src/app/components/Button/Button";
import { useDispatch } from "react-redux";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as Stars } from "src/images/ai-stars-white.svg";
import { ReactComponent as AiChat } from "src/images/ai-chat.svg";
import {
  Dropdown,
  DropdownMenu,
  DropdownMenuItem,
} from "src/app/components/Dropdown/Dropdown";
import DismissibleTooltip from "src/app/components/DismissibleTooltip/DismissibleTooltip";
import { openAIChatWithContext } from "src/redux/ai-chat/aiChatActions";

interface StartConversationButtonProps {
  wsGlobalTasks: Array<{ uuid: string; title: string }>;
  wsWorkspaceUuid: string;
  onClearAllSelected: () => void;
}

export default function CreatorDatabaseStartWithAiConversation({
  wsGlobalTasks,
  onClearAllSelected,
}: StartConversationButtonProps) {
  const dispatch = useDispatch();

  const ASK_AI_TOOLTIP_KEY = "askAITooltipHiddenSingleProject" as const;

  return (
    <>
      <DismissibleTooltip
        storageKey={ASK_AI_TOOLTIP_KEY}
        tooltipId="ask-ai-tooltip"
        title={
          <IDHFormattedMessage id="ws_ask_ai_title" defaultMessage="Ask AI" />
        }
        description={
          <IDHFormattedMessage
            id="ws_ask_ai_description"
            defaultMessage="Upload the campaign brief and take advantage of AI support."
          />
        }
        checkboxLabel={
          <IDHFormattedMessage
            id="ws_dont_show_me_again"
            defaultMessage="Don't show me again"
          />
        }
        confirmLabel={<IDHFormattedMessage id="ws_ok" defaultMessage="Ok" />}
      />

      <Dropdown toBottom>
        {(isOpen, setIsOpen) => (
          <>
            <Button
              size="large"
              variant="white"
              data-tooltip-id="ask-ai-tooltip"
              data-qa="ask-ai-button"
              onClick={() => setIsOpen((prev) => !prev)}
            >
              <Stars />
              <IDHFormattedMessage id="ws_ask_ai" defaultMessage="Ask AI..." />
            </Button>

            <DropdownMenu isOpen={isOpen}>
              <DropdownMenuItem
                className="ws-button--white ai-start-conversation"
                data-qa="talk-with-ai-button"
                key="talk-with-ai-button"
                onClick={() => {
                  dispatch(
                    openAIChatWithContext({
                      type: "selectedWsGlobalTasks",
                      data: wsGlobalTasks,
                    }),
                  );
                  setIsOpen(false);
                  onClearAllSelected();
                }}
              >
                <AiChat />
                <IDHFormattedMessage
                  id="ws_start_conversation_ai"
                  defaultMessage="Start conversation"
                />
              </DropdownMenuItem>
            </DropdownMenu>
          </>
        )}
      </Dropdown>
    </>
  );
}
